// The record-payment method list, shared by RecordPaymentDialog, the quote
// drawer's inline record panel and useRecordPaymentForm (#1559). Named apart
// from the PAYMENT_METHODS tuple in src/types/quotes.ts.
export const RECORD_PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "etransfer", label: "E-Transfer" },
  { value: "credit_card", label: "Credit Card" },
  { value: "check", label: "Check" },
  { value: "square", label: "Square" },
  { value: "other", label: "Other" },
] as const;

// Methods where the figure staff enter is what the card was charged, card fee
// included (#1138).
export const CARD_METHODS: ReadonlySet<string> = new Set(["credit_card", "square"]);
